export class LoadFinOpsAwsResourcesHistoricalData {
    static type = '[FINOPS][AWS][RESOURCES] LoadFinOpsAwsResourcesHistoricalData'
}

export class LoadDataTableAllAccountsFinOpsAwsResources {
    static type = '[FINOPS][AWS][RESOURCES] LoadDataTableAllAccountsFinOpsAwsResources'
}

export class ClearFinOpsAwsResource {
    static type = '[FINOPS][AWS][RESOURCES] ClearFinOpsAwsResource'
    constructor() { }
}

export class SetFinOpsAwsResource {
    static type = '[FINOPS][AWS][RESOURCES] SetFinOpsAwsResource'
    constructor(public accountId: string | undefined, public resourceId: string, public selectedDate?: Date) { }
}

export class LoadFinOpsAwsResourcesChartsData {
    static type = '[FINOPS][AWS][RESOURCES] LoadFinOpsAwsResourcesChartsData'
}

export class LoadFinOpsAwsResourcesAllAccountsChartsFilteredData {
    static type = '[FINOPS][AWS][RESOURCES] LoadFinOpsAwsResourcesAllAccountsChartsFilteredData'
}

export class SelectFinOpsDetailsInstance {
    static type = '[FINOPS][AWS][RESOURCES] SelectFinOpsDetailsInstance'
    constructor(public payload: any) { }
}
